import { memo } from 'react';

import { Dollhouse as DollhouseBase, PostEffects } from '@spazious/dollhouse-engine';
import { useStore } from '@spazious/dollhouse-store';

import { AnnotationControls } from '../AnnotationControls/index.js';
import { CameraControls } from '../CameraControls/index.js';
import { CollisionControls } from '../CollisionControls/index.js';
import { DragAndDrop } from '../DragAndDrop/index.js';
import { DrawFsetup } from '../DrawFsetup/index.js';
import { FAreaControls } from '../FAreaControls/index.js';
import { Features } from '../Features/index.js';
import { Hud } from '../Hud/index.js';
import { MeasurementControls } from '../MeasurementControls/index.js';
import { NavMesh } from '../NavMesh/NavMesh.js';
import { NumberingControls } from '../NumberingControls/index.js';
import { Shadows } from '../Shadows/index.js';
import { Stage } from '../Stage/index.js';
import { StyledGrid } from '../StyledGrid/index.js';

export const Dollhouse = memo(() => {
  const camera = useStore(({ camera }) => camera);

  return (
    <DollhouseBase
      shadows
      camera={camera}
      gl={{
        powerPreference: 'high-performance',
        preserveDrawingBuffer: true,
        autoClear: true,
        antialias: false,
        stencil: false,
        depth: false,
      }}
    >
      <pointLight intensity={0.5} position={[0, 10, 0]} />
      <CameraControls />
      <Stage />
      <Shadows />
      <StyledGrid />
      <MeasurementControls />
      <AnnotationControls />
      <NumberingControls />
      <FAreaControls />
      <CollisionControls />
      <DragAndDrop />
      <NavMesh />
      <PostEffects />
      <Features features="hud">
        <Hud axes={false} />
      </Features>
      <DrawFsetup />
    </DollhouseBase>
  );
});
